import { AnyType } from '@thehubz/shared/model';

/**
 * Check if a value is empty, null, undefined, 0, false, empty array or empty object
 *
 * @param value any value
 * @returns true if the value is empty, null, undefined, 0, false, empty array or empty object
 */
export function isNot(value: AnyType) {
  if (value === null || value === undefined || value === '' || value === 0 || value === false) {
    return true;
  }

  // check empty array
  if (Array.isArray(value) && value.length === 0) {
    return true;
  }

  // check empty object
  if (typeof value === 'object' && Object.keys(value).length === 0) {
    return true;
  }

  return false;
}

export function waitForElement(selector: string, timeout = 5000): Promise<HTMLElement> {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const checkElement = () => {
      const element = document.querySelector(selector) as HTMLElement;

      if (element) {
        resolve(element);
      } else if (Date.now() - startTime < timeout) {
        requestAnimationFrame(checkElement);
      } else {
        reject(new Error(`Element with selector ${selector} not found within ${timeout}ms.`));
      }
    };

    checkElement();
  });
}
